import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Loader from './Loader';
const ProtectedRoute = ({ authenticateCallback, authorizedCallback, tokenPrefix = '', isMockData }) => {
    const accessToken = sessionStorage.getItem(`${tokenPrefix}accessToken`);
    const isAuthorized = accessToken || isMockData;
    useEffect(() => {
        if (isAuthorized) {
            if (authorizedCallback)
                authorizedCallback();
        }
        else if (authenticateCallback)
            authenticateCallback();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return isAuthorized ? _jsx(Outlet, {}) : _jsx(Loader, {});
};
export default ProtectedRoute;
